// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3IoWy","dragIcon":"Choice_dragIcon__1xnb4","left":"Choice_left__1R3rJ","input":"Choice_input__17P4T"};